import {createAction} from '@reduxjs/toolkit';

export const exceptionCaughtAction = createAction<Error>('EXCEPTION_CAUGHT');
